const state = {
  user: {
    isLogin: false,
    token: '',
    tokenRefreshTime: null,
    name: null
  },
  driver: {
    name: '',
    state: '',
    year: '',
    make: '',
    model: '',
    licensePlate: '',
    vehicleLicenseState: '',
    division: '',
    jobTitle: '',
    vehicleId: '',
    testFunctions: false
  },
  shift: {
    isStarted: null,
    id: null,
    events: []
  },
  workday: {
    id: null,
    isStarted: null
  },
  currentJob: null,
  currentStand: null,
  currentSheetName: null,
  jobs: {
    images: [],
    signatures: []
  },
  activeJob: {
    id: null,
    isStarted: null,
    startTime: null,
    endTime: null
  },
  createdCustomJob: {
    jobId: null,
    locationId: null,
    nameAdress: null,
    jobActionType: null
  },
  // Scheme of completedJobActions
  // jobActionType
  // standId
  // jobId
  completedJobActions: [],
  // Scheme of stands
  // jobId: jobId
  // standId: standId
  // isActive: false
  // isCompleted: false
  // isSkipped: false
  stands: [],

  // Used to choose jobActionForm depending on stand class
  standClass: {
    'Physical': 1,
    'Electronic': 2,
    'Delivery': 4,
    'NRS': 8,
    'All': 6
  },
  formType: {
    all: 6,
    standService: 1,
    eboardService: 2,
    tabletService: 3,
    delivery: 4,
    standInfo: 5
  },
  driverJobs: [],
  // Scheme of positionArray
  // latitude: latitude,
  // longitude: longitude,
  // timestamp: timestamp
  // positionArray: [],
  // Scheme of customFormArray
  // latitude: latitude,
  // longitude: longitude,
  // timestamp: timestamp
  customForms: [],
  currentCustomForm: ''
}
export default state
